import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Components from '../../../components';
import Client from '../../../services'

const headerMap = {
    "index": {label: "Sl.No.",},
    "_id": {label: "Id",},
    "username": {label: "Username",},
    "name": {label: "Name",},
    "address": {label: "Address",},
    "createdAt": {label: "Created At",}
}

const getValue = (changedValue, dataValue) => {
    if(changedValue === null || changedValue === undefined) return dataValue;
    return changedValue;
}

const StudentInfo = ({data, changes, edit, onChange}) => {


    return <table style={{flex: 1}}>
        <tbody>
            <tr>
                <td>Username:</td>
                <td>{data.username}</td>
            </tr>
            <tr>
                <td>Name:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="name" 
                            onChange={onChange}
                            value={getValue(changes.name, data.name)} 
                        />
                        :
                        data.name
                    }
                </td>
            </tr>
            <tr>
                <td>Address:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="address" 
                            onChange={onChange}
                            value={getValue(changes.address, data.address)} 
                        />
                        :
                        data.address
                    }
                </td>
            </tr>
            <tr>
                <td>Date of Birth:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="dob" 
                            type="date"
                            onChange={onChange}
                            value={getValue(changes.dob, data.dob)} 
                        />
                        :
                        !data.dob ? null : new Date(data.dob).toDateString()
                    }
                
                </td>
            </tr>
            <tr>
                <td>Email:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="email"
                            type="email"
                            onChange={onChange}
                            value={getValue(changes.email, data.email)} 
                        />
                        :
                        data.email
                    }
                </td>
            </tr>
            <tr>
                <td>Contact:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="contact" 
                            onChange={onChange}
                            value={getValue(changes.contact, data.contact)} 
                        />
                        :
                        data.contact
                    }    
                </td>
            </tr>
            <tr>
                <td>Father:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="father" 
                            onChange={onChange}
                            value={getValue(changes.father, data.data.father)} 
                        />
                        :
                        data.data.father
                    }
                </td>
            </tr>
            <tr>
                <td>Mother:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="mother" 
                            onChange={onChange}
                            value={getValue(changes.mother, data.data.mother)} 
                        />
                        :
                        data.data.mother
                    }

                </td>
            </tr>
            <tr>
                <td>School:</td>
                <td>
                    {
                        edit ?
                        <Components.input.TextInput 
                            name="school" 
                            onChange={onChange}
                            value={getValue(changes.school, data.data.school)} 
                        />
                        :
                        data.data.school
                    }
                </td>
            </tr>
        </tbody>
    </table>
}


const StudentProfile = ({...props}) => {
    
    var [student, setStudent] = useState(null)

    // Component Did mount
    useEffect(async()=>{
        const {id} = props.match.params
        const url = Client.api.getScopedUrl(`/student/${id}`)
        const {success, data} = await Client.api.get(url)
        if(success){
            setStudent(data)
        }else{
            setStudent({})
        }
    },[])

    
    if(!student) return null;
    
    

    return <div className="student-profile">
        <nav className="u-flex--center-cross" style={{display: "flex"}}>
            <h2>Student Profile</h2>
            <div style={{flex: 1}}></div>
            <Link to={`/common/exam/marksheet?_student=${student._id}`}>Show Marksheets</Link>
        </nav>
        <div style={{display: 'flex'}}>
            <StudentInfo data={student}/>
            <div style={{width: 200}}>
                <Components.data.Avatar
                    src={student.photo}
                />
            </div>
        </div>
    </div>
}

export default StudentProfile